/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ speakerName: NonNullable<unknown> }} Speakers_Add_Speaker_Aria_LabelInputs */

const en_speakers_add_speaker_aria_label = /** @type {(inputs: Speakers_Add_Speaker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add ${i?.speakerName} as speaker`)
};

const fr_speakers_add_speaker_aria_label = /** @type {(inputs: Speakers_Add_Speaker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajouter ${i?.speakerName} en tant qu'intervenant`)
};

const de_speakers_add_speaker_aria_label = /** @type {(inputs: Speakers_Add_Speaker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Füge ${i?.speakerName} als Lautsprecher hinzu`)
};

const it_speakers_add_speaker_aria_label = /** @type {(inputs: Speakers_Add_Speaker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aggiungi ${i?.speakerName} come relatore`)
};

const ru_speakers_add_speaker_aria_label = /** @type {(inputs: Speakers_Add_Speaker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Добавить ${i?.speakerName} в качестве динамика`)
};

const es_speakers_add_speaker_aria_label = /** @type {(inputs: Speakers_Add_Speaker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Añadir ${i?.speakerName} como orador`)
};

const zh_cn2_speakers_add_speaker_aria_label = /** @type {(inputs: Speakers_Add_Speaker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`添加 ${i?.speakerName} 为扬声器`)
};

const ja_speakers_add_speaker_aria_label = /** @type {(inputs: Speakers_Add_Speaker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakerName} をスピーカーとして追加`)
};

const hi_speakers_add_speaker_aria_label = /** @type {(inputs: Speakers_Add_Speaker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakerName} को स्पीकर के रूप में जोड़ें`)
};

const pt_pt2_speakers_add_speaker_aria_label = /** @type {(inputs: Speakers_Add_Speaker_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adicione ${i?.speakerName} como alto-falante`)
};

/**
* | output |
* | --- |
* | "Add {speakerName} as speaker" |
*
* @param {Speakers_Add_Speaker_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_add_speaker_aria_label = /** @type {((inputs: Speakers_Add_Speaker_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Add_Speaker_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_add_speaker_aria_label(inputs)
	if (locale === "de") return de_speakers_add_speaker_aria_label(inputs)
	if (locale === "it") return it_speakers_add_speaker_aria_label(inputs)
	if (locale === "ru") return ru_speakers_add_speaker_aria_label(inputs)
	if (locale === "es") return es_speakers_add_speaker_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_add_speaker_aria_label(inputs)
	if (locale === "ja") return ja_speakers_add_speaker_aria_label(inputs)
	if (locale === "hi") return hi_speakers_add_speaker_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_add_speaker_aria_label(inputs)
	return en_speakers_add_speaker_aria_label(inputs)
});